import { TextAnchorCell } from "@similarweb/pro-logic-components";

import { allTrackers } from "app/services/track/track";

import { SelectableTextCell } from "./SelectableTextCell";
import { ensureProtocol } from "./utils";
import { renderWebsiteTooltipCell } from "./websiteTooltipCell";

export const renderCampaignNameCell = (name: string) => (
    <SelectableTextCell
        value={name}
        dataAutomation="campaigns-campaign-name"
    />
);

export const renderLandingPageLinkCell = (link: string) => (
    <TextAnchorCell
        target="_blank"
        href={ensureProtocol(link)}
        onClick={() => {
            allTrackers.dispatchTrackEvent("External Link", "click", `Table/URL/${link}`);
        }}
    >
        {link}
    </TextAnchorCell>
);

// Clicking an advertiser swaps the analyzed asset from the industry to that domain,
// mirroring the Top Domains table.
export const renderAdvertiserCell = (advertiser: string, onAdvertiserClick?: (domain: string) => void) =>
    renderWebsiteTooltipCell(
        advertiser,
        onAdvertiserClick
            ? { onDomainClick: onAdvertiserClick, dataAutomation: "industry-campaigns-advertiser-link" }
            : undefined,
    );
